import React from 'react';

const Header = ({ count }) => {
  return (
    <div>
      <h4 className="md-font center mt-5 mb-4"> CART </h4>
      <p className="dm-font center">You are eligable for free shipping! </p>
    </div>
  );
};

export default Header;
